import axios from '../axios'

const getCSRFTokenApi = () => axios.get('sanctum/csrf-cookie');

export default getCSRFTokenApi;
